module.exports = __webpack_public_path__ + "static/timeline2000-c2cd385664fb06a5c994d8080594eaba.jpeg";